import { FormControl, FormHelperText, makeStyles } from "@material-ui/core";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useCallback } from "react";
import dayjs from "dayjs";
import { useEnumStrings } from "../../enumStrings";

const useStyles = makeStyles((theme: any) => ({
  formInput: {
    marginTop: "50px",
    paddingBottom: "10px",
    [theme.breakpoints.down("sm")]: {
      width: "265px",
      height: "55px",
    },
    [theme.breakpoints.up("sm")]: {
      width: "431px",
      height: "55px",
    },
    borderRadius: "15px",
  },
  formInputFullWidth: {
    marginTop: "0px",
    paddingBottom: "0px",
    width: "100%",
    borderRadius: "8px",
  },
  selectedValue: {
    backgroundColor: "#F2F2F6",
    borderRadius: "15px",
    [theme.breakpoints.down("sm")]: {
      width: "265px",
      height: "55px",
    },
    [theme.breakpoints.up("sm")]: {
      width: "431px",
      height: "55px",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "black",
        borderRadius: "15px",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#E1A731",
      },
    },
    "& label.Mui-focused": {
      color: "#E1A731",
    },
    "& label.Mui": {
      color: "black",
    },
  },
  selectedValueFullWidth: {
    backgroundColor: "#FAFAFA",
    borderRadius: "8px",
    width: "100%",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#E0E0E0",
        borderRadius: "8px",
      },
      "&:hover fieldset": {
        borderColor: "#BDBDBD",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#E1A731",
        borderWidth: "2px",
      },
    },
    "& label.Mui-focused": {
      color: "#E1A731",
    },
    "& label.Mui": {
      color: "#999",
    },
    "& .MuiInputBase-input": {
      padding: "14px 16px",
      fontSize: "14px",
    },
  },
}));

const ShopLocalCampaignEndDatePicker = ({
  formikSetFieldValue,
  formikErrors,
  formikVal,
  disabled,
  isForStartDate,
  startAfterDate,
  fullWidth,
}: {
  formikSetFieldValue: (a: string, b: number) => void;
  formikErrors: any;
  formikVal: number;
  disabled?: boolean;
  isForStartDate?: boolean;
  startAfterDate?: number;
  fullWidth?: boolean;
}) => {
  const classes = useStyles();

  const handleDateChange = useCallback(
    (val) => {
      formikSetFieldValue(
        isForStartDate ? "startDateUtcMilli" : "endDateUtcMilli",
        isForStartDate
          ? dayjs(val).startOf("day").valueOf()
          : dayjs(val).valueOf()
      );
    },
    [formikSetFieldValue, isForStartDate]
  );

  const enumStrings = useEnumStrings();

  return (
    <FormControl
      className={fullWidth ? classes.formInputFullWidth : classes.formInput}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MobileDatePicker
          disabled={disabled}
          minDate={
            (startAfterDate || 0) > 0 ? dayjs(startAfterDate) : undefined
          }
          label={
            isForStartDate
              ? enumStrings.shopLocal.shopLocalDatePicker.contestStartDate
              : enumStrings.shopLocal.shopLocalDatePicker.contestEndDate
          }
          className={
            fullWidth ? classes.selectedValueFullWidth : classes.selectedValue
          }
          format="ll"
          onChange={handleDateChange}
          value={formikVal > 0 ? dayjs(formikVal) : undefined}
        />
      </LocalizationProvider>
      {formikErrors && (
        <FormHelperText
          component="legend"
          style={{
            color: fullWidth ? "#E1A731" : "#f44336",
            paddingLeft: fullWidth ? "0px" : "10px",
            paddingTop: "5px",
            marginBottom: "-5px",
            textAlign: fullWidth ? "left" : "center",
            fontSize: fullWidth ? "12px" : undefined,
          }}
        >
          {formikErrors}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default ShopLocalCampaignEndDatePicker;
